// Define factor weights - should match backend weights
export const factorWeights = {
  adr: 0.25, // 25%
  review_score: 0.15, // 15%
  review_count: 0.05, // 5%
  availability: 0.25, // 25% (total_available_days + matching_days combined)
  distance: 0.10, // 10%
  rank: 0.20, // 20%
};

// Maximum possible score (sum of all weights)
export const MAX_SCORE = 100

export const FACTOR_COLORS = {
  adr: {
    bg: 'bg-blue-500',
    fill: '#3498DB',
    text: 'text-blue-800',
    border: 'border-blue-500',
    light: 'bg-blue-100'
  },
  review_score: {
    bg: 'bg-cyan-500',
    fill: '#10B981',
    text: 'text-cyan-800',
    border: 'border-cyan-500',
    light: 'bg-cyan-100'
  },
  review_count: {
    bg: 'bg-yellow-500',
    fill: '#F59E0B',
    text: 'text-yellow-800',
    border: 'border-yellow-500',
    light: 'bg-yellow-100'
  },
  availability: {
    bg: 'bg-purple-500',
    fill: '#8B5CF6',
    text: 'text-purple-800',
    border: 'border-purple-500',
    light: 'bg-purple-100'
  },
  distance: {
    bg: 'bg-red-500',
    fill: '#EF4444',
    text: 'text-red-800',
    border: 'border-red-500',
    light: 'bg-red-100'
  },
  rank: {
    bg: 'bg-orange-500',
    fill: '#F97316',
    text: 'text-orange-800',
    border: 'border-orange-500',
    light: 'bg-orange-100'
  }
};